module.exports = __webpack_public_path__ + "img/big_1_77.a5e43f2f.png";